export default "<div class=\"error\" fxLayout=\"column\" fxLayoutAlign=\"center center\">\r\n\r\n\t<h2>Acceso denegado</h2>\r\n\r\n</div>"